import { reactive, readonly, inject, provide } from 'vue';

const ToastSymbol = Symbol('Toast');

export function createToast() {
  const toasts = reactive([]);
  const recentToasts = new Map(); // Para evitar toasts duplicados

  const addToast = ({ type = 'info', title = '', content, duration = 5000 }) => {
    // Criar uma chave única baseada no tipo e título
    const toastKey = `${type}-${title}`;
    const now = Date.now();

    // Verificar se já existe um toast similar nos últimos 1000ms
    if (recentToasts.has(toastKey)) {
      const lastTime = recentToasts.get(toastKey);
      if (now - lastTime < 1000) {
        return; // Ignorar toast duplicado muito próximo
      }
    }

    // Atualizar o timestamp do último toast deste tipo
    recentToasts.set(toastKey, now);

    const id = Date.now() + Math.random();
    toasts.push({ id, type, title, content });

    setTimeout(() => {
      const index = toasts.findIndex((t) => t.id === id);
      if (index !== -1) toasts.splice(index, 1);

      // Limpar entrada do cache se for muito antiga
      if (now - recentToasts.get(toastKey) > duration + 1000) {
        recentToasts.delete(toastKey);
      }
    }, duration);
  };

  const removeToast = (id) => {
    const index = toasts.findIndex((t) => t.id === id);
    if (index !== -1) {
      toasts.splice(index, 1);
    }
  };

  return {
    toasts: readonly(toasts),
    addToast,
    removeToast,
  };
}

export function provideToast() {
  const toast = createToast();
  provide(ToastSymbol, toast);
  return toast;
}

export function useToast() {
  const toast = inject(ToastSymbol);
  if (!toast) throw new Error('useToast must be used after provideToast');
  return toast;
}
